// Per-country accepted digit-length range for the local part (after the
// `+CC` dial code). Mirrors the mobile app's `_phoneLengths` map in
// ship_zone/lib/UI/widgets/country_picker_bottom_sheet.dart so the website
// and mobile share the same validation rules.
//
// `iso` is the ISO 3166-1 alpha-2 country code expected by `vue-flag-icon`
// for rendering the flag.

export const FALLBACK_MIN = 10
export const FALLBACK_MAX = 15

export const COUNTRIES = [
  // Iraq first (default)
  { dialCode: '+964', name: 'Iraq', iso: 'iq', min: 10, max: 10 },

  { dialCode: '+93', name: 'Afghanistan', iso: 'af', min: 9, max: 9 },
  { dialCode: '+355', name: 'Albania', iso: 'al', min: 9, max: 9 },
  { dialCode: '+213', name: 'Algeria', iso: 'dz', min: 9, max: 9 },
  { dialCode: '+1684', name: 'American Samoa', iso: 'as', min: 7, max: 7 },
  { dialCode: '+376', name: 'Andorra', iso: 'ad', min: 6, max: 6 },
  { dialCode: '+244', name: 'Angola', iso: 'ao', min: 9, max: 9 },
  { dialCode: '+1264', name: 'Anguilla', iso: 'ai', min: 7, max: 7 },
  { dialCode: '+1268', name: 'Antigua and Barbuda', iso: 'ag', min: 7, max: 7 },
  { dialCode: '+54', name: 'Argentina', iso: 'ar', min: 10, max: 11 },
  { dialCode: '+374', name: 'Armenia', iso: 'am', min: 8, max: 8 },
  { dialCode: '+297', name: 'Aruba', iso: 'aw', min: 7, max: 7 },
  { dialCode: '+61', name: 'Australia', iso: 'au', min: 9, max: 9 },
  { dialCode: '+43', name: 'Austria', iso: 'at', min: 10, max: 13 },
  { dialCode: '+994', name: 'Azerbaijan', iso: 'az', min: 9, max: 9 },
  { dialCode: '+1242', name: 'Bahamas', iso: 'bs', min: 7, max: 7 },
  { dialCode: '+973', name: 'Bahrain', iso: 'bh', min: 8, max: 8 },
  { dialCode: '+880', name: 'Bangladesh', iso: 'bd', min: 10, max: 10 },
  { dialCode: '+1246', name: 'Barbados', iso: 'bb', min: 7, max: 7 },
  { dialCode: '+375', name: 'Belarus', iso: 'by', min: 9, max: 9 },
  { dialCode: '+32', name: 'Belgium', iso: 'be', min: 9, max: 9 },
  { dialCode: '+501', name: 'Belize', iso: 'bz', min: 7, max: 7 },
  { dialCode: '+229', name: 'Benin', iso: 'bj', min: 8, max: 8 },
  { dialCode: '+1441', name: 'Bermuda', iso: 'bm', min: 7, max: 7 },
  { dialCode: '+975', name: 'Bhutan', iso: 'bt', min: 8, max: 8 },
  { dialCode: '+591', name: 'Bolivia', iso: 'bo', min: 8, max: 8 },
  { dialCode: '+387', name: 'Bosnia and Herzegovina', iso: 'ba', min: 8, max: 8 },
  { dialCode: '+267', name: 'Botswana', iso: 'bw', min: 8, max: 8 },
  { dialCode: '+55', name: 'Brazil', iso: 'br', min: 10, max: 11 },
  { dialCode: '+673', name: 'Brunei', iso: 'bn', min: 7, max: 7 },
  { dialCode: '+359', name: 'Bulgaria', iso: 'bg', min: 8, max: 9 },
  { dialCode: '+226', name: 'Burkina Faso', iso: 'bf', min: 8, max: 8 },
  { dialCode: '+257', name: 'Burundi', iso: 'bi', min: 8, max: 8 },
  { dialCode: '+855', name: 'Cambodia', iso: 'kh', min: 8, max: 9 },
  { dialCode: '+237', name: 'Cameroon', iso: 'cm', min: 9, max: 9 },
  { dialCode: '+1', name: 'Canada', iso: 'ca', min: 10, max: 10 },
  { dialCode: '+238', name: 'Cape Verde', iso: 'cv', min: 7, max: 7 },
  { dialCode: '+1345', name: 'Cayman Islands', iso: 'ky', min: 7, max: 7 },
  { dialCode: '+236', name: 'Central African Republic', iso: 'cf', min: 8, max: 8 },
  { dialCode: '+235', name: 'Chad', iso: 'td', min: 8, max: 8 },
  { dialCode: '+56', name: 'Chile', iso: 'cl', min: 9, max: 9 },
  { dialCode: '+86', name: 'China', iso: 'cn', min: 11, max: 11 },
  { dialCode: '+57', name: 'Colombia', iso: 'co', min: 10, max: 10 },
  { dialCode: '+269', name: 'Comoros', iso: 'km', min: 7, max: 7 },
  { dialCode: '+682', name: 'Cook Islands', iso: 'ck', min: 5, max: 5 },
  { dialCode: '+506', name: 'Costa Rica', iso: 'cr', min: 8, max: 8 },
  { dialCode: '+385', name: 'Croatia', iso: 'hr', min: 9, max: 9 },
  { dialCode: '+53', name: 'Cuba', iso: 'cu', min: 8, max: 8 },
  { dialCode: '+5999', name: 'Curacao', iso: 'cw', min: 7, max: 7 },
  { dialCode: '+357', name: 'Cyprus', iso: 'cy', min: 8, max: 8 },
  { dialCode: '+420', name: 'Czech Republic', iso: 'cz', min: 9, max: 9 },
  { dialCode: '+243', name: 'Democratic Republic of Congo', iso: 'cd', min: 9, max: 9 },
  { dialCode: '+45', name: 'Denmark', iso: 'dk', min: 8, max: 8 },
  { dialCode: '+253', name: 'Djibouti', iso: 'dj', min: 8, max: 8 },
  { dialCode: '+1767', name: 'Dominica', iso: 'dm', min: 7, max: 7 },
  { dialCode: '+1809', name: 'Dominican Republic', iso: 'do', min: 7, max: 7 },
  { dialCode: '+670', name: 'East Timor', iso: 'tl', min: 8, max: 8 },
  { dialCode: '+593', name: 'Ecuador', iso: 'ec', min: 9, max: 9 },
  { dialCode: '+20', name: 'Egypt', iso: 'eg', min: 10, max: 10 },
  { dialCode: '+503', name: 'El Salvador', iso: 'sv', min: 8, max: 8 },
  { dialCode: '+240', name: 'Equatorial Guinea', iso: 'gq', min: 9, max: 9 },
  { dialCode: '+291', name: 'Eritrea', iso: 'er', min: 7, max: 7 },
  { dialCode: '+372', name: 'Estonia', iso: 'ee', min: 7, max: 8 },
  { dialCode: '+251', name: 'Ethiopia', iso: 'et', min: 9, max: 9 },
  { dialCode: '+268', name: 'Eswatini', iso: 'sz', min: 8, max: 8 },
  { dialCode: '+500', name: 'Falkland Islands', iso: 'fk', min: 5, max: 5 },
  { dialCode: '+298', name: 'Faroe Islands', iso: 'fo', min: 6, max: 6 },
  { dialCode: '+679', name: 'Fiji', iso: 'fj', min: 7, max: 7 },
  { dialCode: '+358', name: 'Finland', iso: 'fi', min: 9, max: 12 },
  { dialCode: '+33', name: 'France', iso: 'fr', min: 9, max: 9 },
  { dialCode: '+689', name: 'French Polynesia', iso: 'pf', min: 8, max: 8 },
  { dialCode: '+241', name: 'Gabon', iso: 'ga', min: 8, max: 8 },
  { dialCode: '+220', name: 'Gambia', iso: 'gm', min: 7, max: 7 },
  { dialCode: '+995', name: 'Georgia', iso: 'ge', min: 9, max: 9 },
  { dialCode: '+49', name: 'Germany', iso: 'de', min: 10, max: 11 },
  { dialCode: '+233', name: 'Ghana', iso: 'gh', min: 9, max: 9 },
  { dialCode: '+350', name: 'Gibraltar', iso: 'gi', min: 8, max: 8 },
  { dialCode: '+30', name: 'Greece', iso: 'gr', min: 10, max: 10 },
  { dialCode: '+299', name: 'Greenland', iso: 'gl', min: 6, max: 6 },
  { dialCode: '+1473', name: 'Grenada', iso: 'gd', min: 7, max: 7 },
  { dialCode: '+1671', name: 'Guam', iso: 'gu', min: 7, max: 7 },
  { dialCode: '+502', name: 'Guatemala', iso: 'gt', min: 8, max: 8 },
  { dialCode: '+224', name: 'Guinea', iso: 'gn', min: 9, max: 9 },
  { dialCode: '+245', name: 'Guinea-Bissau', iso: 'gw', min: 9, max: 9 },
  { dialCode: '+592', name: 'Guyana', iso: 'gy', min: 7, max: 7 },
  { dialCode: '+509', name: 'Haiti', iso: 'ht', min: 8, max: 8 },
  { dialCode: '+504', name: 'Honduras', iso: 'hn', min: 8, max: 8 },
  { dialCode: '+852', name: 'Hong Kong', iso: 'hk', min: 8, max: 8 },
  { dialCode: '+36', name: 'Hungary', iso: 'hu', min: 9, max: 9 },
  { dialCode: '+354', name: 'Iceland', iso: 'is', min: 7, max: 9 },
  { dialCode: '+91', name: 'India', iso: 'in', min: 10, max: 10 },
  { dialCode: '+62', name: 'Indonesia', iso: 'id', min: 9, max: 12 },
  { dialCode: '+98', name: 'Iran', iso: 'ir', min: 10, max: 10 },
  { dialCode: '+353', name: 'Ireland', iso: 'ie', min: 9, max: 9 },
  { dialCode: '+39', name: 'Italy', iso: 'it', min: 9, max: 11 },
  { dialCode: '+225', name: 'Ivory Coast', iso: 'ci', min: 10, max: 10 },
  { dialCode: '+1876', name: 'Jamaica', iso: 'jm', min: 7, max: 7 },
  { dialCode: '+81', name: 'Japan', iso: 'jp', min: 10, max: 10 },
  { dialCode: '+962', name: 'Jordan', iso: 'jo', min: 9, max: 9 },
  { dialCode: '+7', name: 'Kazakhstan', iso: 'kz', min: 10, max: 10 },
  { dialCode: '+254', name: 'Kenya', iso: 'ke', min: 9, max: 9 },
  { dialCode: '+686', name: 'Kiribati', iso: 'ki', min: 8, max: 8 },
  { dialCode: '+383', name: 'Kosovo', iso: 'xk', min: 8, max: 8 },
  { dialCode: '+965', name: 'Kuwait', iso: 'kw', min: 8, max: 8 },
  { dialCode: '+996', name: 'Kyrgyzstan', iso: 'kg', min: 9, max: 9 },
  { dialCode: '+856', name: 'Laos', iso: 'la', min: 8, max: 10 },
  { dialCode: '+371', name: 'Latvia', iso: 'lv', min: 8, max: 8 },
  { dialCode: '+961', name: 'Lebanon', iso: 'lb', min: 7, max: 8 },
  { dialCode: '+266', name: 'Lesotho', iso: 'ls', min: 8, max: 8 },
  { dialCode: '+231', name: 'Liberia', iso: 'lr', min: 7, max: 8 },
  { dialCode: '+218', name: 'Libya', iso: 'ly', min: 9, max: 10 },
  { dialCode: '+423', name: 'Liechtenstein', iso: 'li', min: 7, max: 7 },
  { dialCode: '+370', name: 'Lithuania', iso: 'lt', min: 8, max: 8 },
  { dialCode: '+352', name: 'Luxembourg', iso: 'lu', min: 9, max: 9 },
  { dialCode: '+853', name: 'Macao', iso: 'mo', min: 8, max: 8 },
  { dialCode: '+261', name: 'Madagascar', iso: 'mg', min: 9, max: 9 },
  { dialCode: '+265', name: 'Malawi', iso: 'mw', min: 9, max: 9 },
  { dialCode: '+60', name: 'Malaysia', iso: 'my', min: 9, max: 10 },
  { dialCode: '+960', name: 'Maldives', iso: 'mv', min: 7, max: 7 },
  { dialCode: '+223', name: 'Mali', iso: 'ml', min: 8, max: 8 },
  { dialCode: '+356', name: 'Malta', iso: 'mt', min: 8, max: 8 },
  { dialCode: '+692', name: 'Marshall Islands', iso: 'mh', min: 7, max: 7 },
  { dialCode: '+222', name: 'Mauritania', iso: 'mr', min: 8, max: 8 },
  { dialCode: '+230', name: 'Mauritius', iso: 'mu', min: 7, max: 8 },
  { dialCode: '+52', name: 'Mexico', iso: 'mx', min: 10, max: 10 },
  { dialCode: '+691', name: 'Micronesia', iso: 'fm', min: 7, max: 7 },
  { dialCode: '+373', name: 'Moldova', iso: 'md', min: 8, max: 8 },
  { dialCode: '+377', name: 'Monaco', iso: 'mc', min: 8, max: 8 },
  { dialCode: '+976', name: 'Mongolia', iso: 'mn', min: 8, max: 8 },
  { dialCode: '+382', name: 'Montenegro', iso: 'me', min: 8, max: 8 },
  { dialCode: '+1664', name: 'Montserrat', iso: 'ms', min: 7, max: 7 },
  { dialCode: '+212', name: 'Morocco', iso: 'ma', min: 9, max: 9 },
  { dialCode: '+258', name: 'Mozambique', iso: 'mz', min: 9, max: 9 },
  { dialCode: '+95', name: 'Myanmar', iso: 'mm', min: 8, max: 10 },
  { dialCode: '+264', name: 'Namibia', iso: 'na', min: 9, max: 9 },
  { dialCode: '+674', name: 'Nauru', iso: 'nr', min: 7, max: 7 },
  { dialCode: '+977', name: 'Nepal', iso: 'np', min: 10, max: 10 },
  { dialCode: '+31', name: 'Netherlands', iso: 'nl', min: 9, max: 9 },
  { dialCode: '+64', name: 'New Zealand', iso: 'nz', min: 8, max: 10 },
  { dialCode: '+505', name: 'Nicaragua', iso: 'ni', min: 8, max: 8 },
  { dialCode: '+227', name: 'Niger', iso: 'ne', min: 8, max: 8 },
  { dialCode: '+234', name: 'Nigeria', iso: 'ng', min: 10, max: 10 },
  { dialCode: '+683', name: 'Niue', iso: 'nu', min: 4, max: 4 },
  { dialCode: '+850', name: 'North Korea', iso: 'kp', min: 8, max: 12 },
  { dialCode: '+389', name: 'North Macedonia', iso: 'mk', min: 8, max: 8 },
  { dialCode: '+47', name: 'Norway', iso: 'no', min: 8, max: 8 },
  { dialCode: '+968', name: 'Oman', iso: 'om', min: 8, max: 8 },
  { dialCode: '+92', name: 'Pakistan', iso: 'pk', min: 10, max: 10 },
  { dialCode: '+680', name: 'Palau', iso: 'pw', min: 7, max: 7 },
  { dialCode: '+970', name: 'Palestine', iso: 'ps', min: 9, max: 9 },
  { dialCode: '+507', name: 'Panama', iso: 'pa', min: 8, max: 8 },
  { dialCode: '+675', name: 'Papua New Guinea', iso: 'pg', min: 8, max: 8 },
  { dialCode: '+595', name: 'Paraguay', iso: 'py', min: 9, max: 9 },
  { dialCode: '+51', name: 'Peru', iso: 'pe', min: 9, max: 9 },
  { dialCode: '+63', name: 'Philippines', iso: 'ph', min: 10, max: 10 },
  { dialCode: '+48', name: 'Poland', iso: 'pl', min: 9, max: 9 },
  { dialCode: '+351', name: 'Portugal', iso: 'pt', min: 9, max: 9 },
  { dialCode: '+1787', name: 'Puerto Rico', iso: 'pr', min: 7, max: 7 },
  { dialCode: '+974', name: 'Qatar', iso: 'qa', min: 8, max: 8 },
  { dialCode: '+242', name: 'Republic of the Congo', iso: 'cg', min: 9, max: 9 },
  { dialCode: '+40', name: 'Romania', iso: 'ro', min: 9, max: 9 },
  { dialCode: '+250', name: 'Rwanda', iso: 'rw', min: 9, max: 9 },
  { dialCode: '+685', name: 'Samoa', iso: 'ws', min: 7, max: 7 },
  { dialCode: '+378', name: 'San Marino', iso: 'sm', min: 10, max: 10 },
  { dialCode: '+239', name: 'Sao Tome and Principe', iso: 'st', min: 7, max: 7 },
  { dialCode: '+966', name: 'Saudi Arabia', iso: 'sa', min: 9, max: 9 },
  { dialCode: '+221', name: 'Senegal', iso: 'sn', min: 9, max: 9 },
  { dialCode: '+381', name: 'Serbia', iso: 'rs', min: 9, max: 9 },
  { dialCode: '+248', name: 'Seychelles', iso: 'sc', min: 7, max: 7 },
  { dialCode: '+232', name: 'Sierra Leone', iso: 'sl', min: 8, max: 8 },
  { dialCode: '+65', name: 'Singapore', iso: 'sg', min: 8, max: 8 },
  { dialCode: '+1721', name: 'Sint Maarten', iso: 'sx', min: 7, max: 7 },
  { dialCode: '+421', name: 'Slovakia', iso: 'sk', min: 9, max: 9 },
  { dialCode: '+386', name: 'Slovenia', iso: 'si', min: 8, max: 8 },
  { dialCode: '+677', name: 'Solomon Islands', iso: 'sb', min: 7, max: 7 },
  { dialCode: '+252', name: 'Somalia', iso: 'so', min: 8, max: 9 },
  { dialCode: '+27', name: 'South Africa', iso: 'za', min: 9, max: 9 },
  { dialCode: '+82', name: 'South Korea', iso: 'kr', min: 9, max: 10 },
  { dialCode: '+211', name: 'South Sudan', iso: 'ss', min: 9, max: 9 },
  { dialCode: '+34', name: 'Spain', iso: 'es', min: 9, max: 9 },
  { dialCode: '+94', name: 'Sri Lanka', iso: 'lk', min: 9, max: 9 },
  { dialCode: '+1869', name: 'St Kitts and Nevis', iso: 'kn', min: 7, max: 7 },
  { dialCode: '+1758', name: 'St Lucia', iso: 'lc', min: 7, max: 7 },
  { dialCode: '+1784', name: 'St Vincent and the Grenadines', iso: 'vc', min: 7, max: 7 },
  { dialCode: '+249', name: 'Sudan', iso: 'sd', min: 9, max: 9 },
  { dialCode: '+597', name: 'Suriname', iso: 'sr', min: 7, max: 7 },
  { dialCode: '+46', name: 'Sweden', iso: 'se', min: 7, max: 13 },
  { dialCode: '+41', name: 'Switzerland', iso: 'ch', min: 9, max: 9 },
  { dialCode: '+963', name: 'Syria', iso: 'sy', min: 9, max: 9 },
  { dialCode: '+886', name: 'Taiwan', iso: 'tw', min: 9, max: 9 },
  { dialCode: '+992', name: 'Tajikistan', iso: 'tj', min: 9, max: 9 },
  { dialCode: '+255', name: 'Tanzania', iso: 'tz', min: 9, max: 9 },
  { dialCode: '+66', name: 'Thailand', iso: 'th', min: 9, max: 9 },
  { dialCode: '+228', name: 'Togo', iso: 'tg', min: 8, max: 8 },
  { dialCode: '+676', name: 'Tonga', iso: 'to', min: 5, max: 7 },
  { dialCode: '+1868', name: 'Trinidad and Tobago', iso: 'tt', min: 7, max: 7 },
  { dialCode: '+216', name: 'Tunisia', iso: 'tn', min: 8, max: 8 },
  { dialCode: '+90', name: 'Turkey', iso: 'tr', min: 10, max: 10 },
  { dialCode: '+993', name: 'Turkmenistan', iso: 'tm', min: 8, max: 8 },
  { dialCode: '+1649', name: 'Turks and Caicos', iso: 'tc', min: 7, max: 7 },
  { dialCode: '+688', name: 'Tuvalu', iso: 'tv', min: 5, max: 6 },
  { dialCode: '+256', name: 'Uganda', iso: 'ug', min: 9, max: 9 },
  { dialCode: '+380', name: 'Ukraine', iso: 'ua', min: 9, max: 9 },
  { dialCode: '+971', name: 'United Arab Emirates', iso: 'ae', min: 9, max: 9 },
  { dialCode: '+44', name: 'United Kingdom', iso: 'gb', min: 10, max: 10 },
  { dialCode: '+1', name: 'United States', iso: 'us', min: 10, max: 10 },
  { dialCode: '+598', name: 'Uruguay', iso: 'uy', min: 8, max: 8 },
  { dialCode: '+998', name: 'Uzbekistan', iso: 'uz', min: 9, max: 9 },
  { dialCode: '+678', name: 'Vanuatu', iso: 'vu', min: 5, max: 7 },
  { dialCode: '+379', name: 'Vatican City', iso: 'va', min: 10, max: 10 },
  { dialCode: '+58', name: 'Venezuela', iso: 've', min: 10, max: 10 },
  { dialCode: '+84', name: 'Vietnam', iso: 'vn', min: 9, max: 10 },
  { dialCode: '+1340', name: 'Virgin Islands', iso: 'vi', min: 7, max: 7 },
  { dialCode: '+967', name: 'Yemen', iso: 'ye', min: 9, max: 9 },
  { dialCode: '+260', name: 'Zambia', iso: 'zm', min: 9, max: 9 },
  { dialCode: '+263', name: 'Zimbabwe', iso: 'zw', min: 9, max: 9 }
]

// Lookup helper: longest-prefix match against COUNTRIES so overlapping codes
// like `+1` vs `+1264` resolve correctly.
export function splitPhoneByCountry(fullPhone) {
  if (!fullPhone) return null
  const sorted = [...COUNTRIES].sort((a, b) => b.dialCode.length - a.dialCode.length)
  for (const c of sorted) {
    if (fullPhone.startsWith(c.dialCode)) {
      return { country: c, localDigits: fullPhone.slice(c.dialCode.length) }
    }
  }
  return null
}

export function findCountryByDialCode(dialCode) {
  return COUNTRIES.find((c) => c.dialCode === dialCode) || null
}



// WEBPACK FOOTER //
// ./src/data/phoneLengths.js